module.exports = __webpack_public_path__ + "static/media/stroke_pink_01.fa6d9873.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pre-auth/themesLPV2/decorations/stroke_pink_01.svg
// module id = 2425
// module chunks = 47